import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { DropDownOption } from '@app/interfaces/IDropDown';
import { MatSelect } from '@angular/material/select';
import { TourGuideService } from '@app/services/tour-guide.service';
import { Subscription } from 'rxjs';
/**
 *  Dropdown component
 *  Used to display the dropdown
 *
 *  Takes options, title, default selected as input
 *  Emit events whenever user selects another option
 */

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})

export class DropdownComponent implements OnDestroy {
  
  /****************** Variable declaration ******************/
  dataSubscription: Subscription
  
  /****************** View child ******************/
  @ViewChild('select') matSelect: MatSelect;

  /****************** Input and Output decorators ******************/
  @Input() chart: string;
  @Input() selectedOption: DropDownOption; // default selected option
  @Input() title: string | undefined; // title to display in dropdown
  @Input() options: DropDownOption[]; // options of the dropdown
  @Input() customWidth: any = 'auto';
  @Input() customHight: any = '4.3rem';
  @Input() style: any
  /** event emitter whenever different value is chosen */
  @Output() dropDownUpdate = new EventEmitter<string>();

  /**
   * Constructor
   * @param guideService 
   */
  constructor(private guideService: TourGuideService) {
    this.dataSubscription = this.guideService.data$.subscribe((res: any) => {
      if (this.matSelect && res?.operation === 'open') {
        this.matSelect.open()
      }
      if (this.matSelect && res?.operation === 'close') {
        this.matSelect.close()
      }
    })
  }

  /**
   * Emits an event whenever user chooses another option
   * @param newOption
   */
  emitSelectEvent(newOption: any) {
    this.selectedOption = newOption.value;
    this.dropDownUpdate.emit(newOption.value);
  }

  /** ngOnDestroy */
  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe()
  }
}
